import { createFileRoute } from "@tanstack/react-router";

import { SettingsAccountProfile } from "@/features/my/settings/account/profile";

export const Route = createFileRoute(
  "/(member)/(protected)/my/settings/account/profile",
)({
  component: SettingsAccountProfile,
});
